import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { call, cancelCall } from "../../actions/sipActions";
import Standard from "../Standard";
import logo from "../../branding/current/logo.png";
import logoDark from "../../branding/current/logo_dark.png";
import RoundRejectButton from "../../components/buttons/RoundRejectButton";
import RoundAnswerButton from "../../components/buttons/RoundAnswerButton";

export class RejectedRemote extends React.Component {
  rejected_remote = () => {
    var contactName = this.findContactnameFromSip(this.props.callB);

    return (
      <div className={"text-align-center margin-auto"}>
        <h1>
          {contactName} {this.props.l10n("call.rejected")}
        </h1>
        <br />
        <div className={"row text-align-center margin-auto"}>
          <div className={"col"}>
            <RoundAnswerButton
              text={this.props.l10n("common.callagain")}
              onClick={() => this.props.call(this.props.callB)}
            />
          </div>
          <div className={"col"}>
            <RoundRejectButton
              text={this.props.l10n("common.cancel")}
              onClick={() => this.props.cancel()}
              kioskmode={false}
            />
          </div>
        </div>
      </div>
    );
  };

  findContactnameFromSip = sip => {
    for (var i = 0; i < this.props.contacts.length; i++) {
      if (this.props.contacts[i].sipaddress === sip) {
        if (this.props.contacts[i].fname && this.props.contacts[i].sname) {
          return (
            this.props.contacts[i].fname + " " + this.props.contacts[i].sname
          );
        } else if (this.props.contacts[i].fname) {
          return this.props.contacts[i].fname;
        } else if (this.props.contacts[i].sname) {
          return this.props.contacts[i].sname;
        }
      }
    }
    return sip;
  };

  render() {
    const { contrast, l10n } = this.props;
    return (
      <Standard
        logo={logo}
        logoDark={logoDark}
        contrast={contrast}
        l10n={l10n}
        include={this.rejected_remote()}
      />
    );
  }
}

RejectedRemote.propTypes = {
  l10n: PropTypes.func.isRequired,
  contrast: PropTypes.bool.isRequired,
  callB: PropTypes.string.isRequired,
  contacts: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  l10n: state.config.text,
  contrast: state.accessibility.isHighContrast,
  callB: state.call.callB,
  contacts: state.contact.contacts,
});

const mapDispatchToProps = dispatch => ({
  call: to => {
    return dispatch(call(to));
  },
  cancel: () => {
    return dispatch(cancelCall());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RejectedRemote);






// WEBPACK FOOTER //
// ./src/kiosk/callStates/RejectedRemote.jsx